const ids = {
    // Genders
    femaleGenderId: 2,

    // Metrics
    numberMetricId: 1,
    percentMetricId: 2,
    rateMetricId: 3,

    // Measures
    deathMeasureId: 1,
    dalyMeasureId: 2,
    yldMeasureId: 3,
    yllMeasureId: 4,
    prevalenceMeasureId: 5,
    incidenceMeasureId: 6,
    maternalMortalityRatioMeasureId: 25,

    // Locations
    globalLocationId: 1,
    USALocationId: 102,
    highMiddleSdiLocationId: 44634,
    highSdiLocationId: 44635,
    lowMiddleSdiLocationId: 44636,
    lowSdiLocationId: 44637,
    middleSdiLocationId: 44639,

    countryLocationType: 2,
    nonsovereignLocationType: 8,

    // Age Groups
    allAgesGroupId: 22,
    ageStandardizedGroupId: 27,
    tenToFiftyFourAgeGroupId: 169,

    // Causes
    allCausesId: 294,
    cardiovascularDiseases: 491,
};

const chartsConfiguration = {
    // Trends chart
    defaultTrendsLocationId: ids.globalLocationId,
    defaultTrendsMetricId: ids.numberMetricId,
    defaultTrendsMeasureId: ids.dalyMeasureId,
    defaultTrendsAgeGroupId: ids.allAgesGroupId,
    defaultTrendsCauseId: ids.cardiovascularDiseases,

    // Global chart
    defaultGlobalYear: 2022,
    defaultGlobalMetricId: ids.rateMetricId,
    defaultGlobalMeasureId: ids.deathMeasureId,
    defaultGlobalAgeGroupId: ids.ageStandardizedGroupId,
    defaultGlobalCauseId: ids.cardiovascularDiseases,

    // Breakdown chart
    defaultBreakdownLocationId: '1,44635,44637', // Global, High SDI, Low SDI
    defaultBreakdownMetricId: ids.rateMetricId,
    defaultBreakdownMeasureId: ids.prevalenceMeasureId,
    defaultBreakdownAgeGroupId: ids.ageStandardizedGroupId,
    defaultBreakdownCauseId: '492,493,494,498,499,500,501,502,503,504,507',
    defaultBreakdownYear: 2022,

    // Factsheets page
    defaultFactsheetsYear: 2022,
    defaultFactsheetsLocationId: ids.USALocationId,

    // Factsheets Risks chart
    defaultFactsheetsRisksMetricId: ids.rateMetricId,
    defaultFactsheetsRisksMeasureId: ids.dalyMeasureId,
    defaultFactsheetsRisksAgeGroupId: ids.ageStandardizedGroupId,
    defaultFactsheetsRisksCauseId: ids.cardiovascularDiseases,

    // Factsheets Deaths chart
    defaultFactsheetsDeathsMetricId: ids.rateMetricId,
    defaultFactsheetsDeathsMeasureId: ids.deathMeasureId,
    defaultFactsheetsDeathsAgeGroupId: ids.ageStandardizedGroupId,
    defaultFactsheetsDeathsCauseId: ids.cardiovascularDiseases,

    // Factsheets YLL chart
    defaultFactsheetsYLLMetricId: ids.rateMetricId,
    defaultFactsheetsYLLMeasureId: ids.yllMeasureId,
    defaultFactsheetsYLLAgeGroupId: ids.ageStandardizedGroupId,
    defaultFactsheetsYLLCauseId: ids.cardiovascularDiseases,
    defaultFactsheetsYLLLocationTypeId: '2,8',
};

export default {
    ...ids,
    ...chartsConfiguration,

    apiUrl: config.apiUrl,
    appName: 'IHME Cardiovascular Disease',
    // Bumping it makes StorageProvider clear localStorage once (6: drops the old redux `state` key).
    storageCacheVersion: '6',
    googleAnalyticsId: 'G-605RRNFTSS',
    googleAnalyticsDebug: false,
};
